function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { FC, HTMLAttributes } from 'react';
import { Title } from '../../Title';
require("./ProductAttention.css");
var styles = {
  "Root": "ProductAttention-module-Root_1wP"
};
export const ProductAttention = ({
  ...rest
}) => {
  return /*#__PURE__*/React.createElement(Title, _extends({
    tag: "h6",
    weight: "semiBold",
    className: styles.Root
  }, rest), "\u041E\u0431\u0440\u0430\u0442\u0438\u0442\u0435 \u0432\u043D\u0438\u043C\u0430\u043D\u0438\u0435");
};